import { motion, useScroll, useTransform } from "framer-motion";
import { heroDelay } from "../loadState";

const ease = [0.16, 1, 0.3, 1];

const MaskedLine = ({ children, delay }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span className="block" initial={{ y: "112%" }} animate={{ y: 0 }} transition={{ duration: 1.15, delay, ease }}>
      {children}
    </motion.span>
  </span>
);

export const ErthHero = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 900], [0, 200]);

  return (
    <section id="top" data-testid="erth-hero" className="relative flex h-[100svh] min-h-[620px] items-end overflow-hidden bg-erth-black pt-[4.5rem]">
      <motion.div
        className="absolute inset-0"
        initial={{ scale: 1.14, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 2.4, delay: heroDelay(1.4), ease }}
      >
        <motion.img
          src="/images/lounge-palms.webp"
          alt="A glass-walled lounge opening onto a courtyard of palms"
          data-testid="erth-hero-image"
          fetchpriority="high"
          className="h-[115%] w-full object-cover"
          style={{ y }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-erth-black/80 via-erth-black/25 to-erth-black/10" />
      </motion.div>

      <div className="relative z-[2] mx-auto w-full max-w-7xl px-6 pb-24 sm:px-8 sm:pb-28">
        <div className="max-w-3xl text-erth-white">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: heroDelay(1.9), ease }}
            className="mb-6 font-head text-xs font-semibold lowercase tracking-[0.25em] text-erth-white/90"
          >
            erth. escapes · India
          </motion.p>
          <h1 className="font-head text-4xl font-semibold lowercase leading-[1.05] tracking-tight sm:text-6xl lg:text-7xl">
            <MaskedLine delay={heroDelay(2.0)}>spaces that harmonize</MaskedLine>
            <MaskedLine delay={heroDelay(2.14)}>with nature.</MaskedLine>
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: heroDelay(2.4), ease }}
            className="mt-7 max-w-xl font-body text-lg leading-relaxed text-erth-white/95 sm:text-xl"
          >
            Thoughtfully crafted homes and escapes for living, celebrating and reconnecting.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: heroDelay(2.55), ease }}
            className="mt-10 flex flex-col gap-4 sm:flex-row"
          >
            <a
              href="#projects"
              data-testid="erth-hero-projects-cta"
              className="rounded-full bg-erth-white px-9 py-4 text-center font-head text-[14px] font-semibold lowercase text-erth-black transition-colors hover:bg-erth-beige"
            >
              view projects
            </a>
            <a
              href="#story"
              data-testid="erth-hero-story-cta"
              className="rounded-full border border-erth-white/60 px-9 py-4 text-center font-head text-[14px] font-semibold lowercase text-erth-white transition-colors hover:bg-erth-white/10"
            >
              our story
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
